var _path, _path2, _path3, _path4, _path5;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBattery(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39 20.0486V16.5583C38.9974 15.8789 38.7231 15.2282 38.2374 14.7487C37.7517 14.2692 37.094 14 36.4084 14H9.59162C8.90601 14 8.24833 14.2692 7.76259 14.7487C7.27686 15.2282 7.00265 15.8789 7 16.5583V31.4318C7 32.1129 7.27304 32.7662 7.75907 33.2478C8.24509 33.7294 8.90428 34 9.59162 34H36.4084C37.0957 34 37.7549 33.7294 38.2409 33.2478C38.727 32.7662 39 32.1129 39 31.4318V27.9812",
    stroke: "#0061ED",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39.0341 20H40.4061C40.8287 20 41.2341 20.197 41.5329 20.5477C41.8318 20.8984 41.9996 21.374 41.9996 21.87V26.09C42.0042 26.3389 41.9663 26.5864 41.8883 26.8179C41.8102 27.0494 41.6936 27.2603 41.5451 27.4382C41.3967 27.6161 41.2195 27.7575 41.0239 27.8539C40.8283 27.9504 40.6182 28.0001 40.4061 28H39",
    stroke: "#0061ED",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0802 16H9.91979C9.4118 16 9 16.441 9 16.985V31.015C9 31.559 9.4118 32 9.91979 32H14.0802C14.5882 32 15 31.559 15 31.015V16.985C15 16.441 14.5882 16 14.0802 16Z",
    fill: "#0061ED"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0802 16H16.9198C16.4118 16 16 16.441 16 16.985V31.015C16 31.559 16.4118 32 16.9198 32H21.0802C21.5882 32 22 31.559 22 31.015V16.985C22 16.441 21.5882 16 21.0802 16Z",
    fill: "#0061ED"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M28.0802 16H23.9198C23.4118 16 23 16.441 23 16.985V31.015C23 31.559 23.4118 32 23.9198 32H28.0802C28.5882 32 29 31.559 29 31.015V16.985C29 16.441 28.5882 16 28.0802 16Z",
    fill: "#0061ED"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBattery);
export default ForwardRef;